import React from 'react';
import * as Styles from '../style';
import { Icon } from 'semantic-ui-react';
import RuleForm from './RuleForm';

const EditRuleForm = ({ handleClose, formik, firewallServies, uniqueProtocol, objectArr }) => {
  return (
    <Styles.RulesContainer>
      <Styles.AddRuleText>
        <Styles.EditNewRuleSty />
      </Styles.AddRuleText>
      <Styles.FormWrapper>
        <Styles.CloseContainer>
          <Icon name="close" onClick={handleClose} />
        </Styles.CloseContainer>
        <RuleForm
          objectArr={objectArr}
          edit
          firewallServies={firewallServies}
          formik={formik}
          uniqueProtocol={uniqueProtocol}
        />
      </Styles.FormWrapper>
    </Styles.RulesContainer>
  );
};

export default EditRuleForm;
